module.exports = __webpack_public_path__ + "static/media/young-agronomist-showing-some-information-farmer-smartphone-greenhouse-min.391ed6cf.jpg";